import { render, staticRenderFns } from "./GatewayEmpty.vue?vue&type=template&id=2e6d878e&scoped=true"
import script from "./GatewayEmpty.vue?vue&type=script&lang=ts"
export * from "./GatewayEmpty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d878e",
  null
  
)

export default component.exports